import { render } from "./EditWishlist.vue?vue&type=template&id=d4975a06&scoped=true"
import script from "./EditWishlist.vue?vue&type=script&lang=ts"
export * from "./EditWishlist.vue?vue&type=script&lang=ts"

import "./EditWishlist.vue?vue&type=style&index=0&id=d4975a06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d4975a06"

export default script